export const getAddress = async ({ lat, lng, developerKey }) => {
  return new Promise(async (resolve, reject) => {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${developerKey}`
    ).then((res) => res.json());
    resolve(response?.results[2]?.formatted_address || "");
  });
};
